module.exports = __webpack_public_path__ + "zespol_01.jpg?c7cb0dbeb2291ff0bd61a0e1462e51fe";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zespol_01.jpg
// module id = 146
// module chunks = 0